import { makeVar } from "@apollo/client";

// Tracks meetings currently showing the empty-state cards so the surrounding
// profile page can switch Layout.Main to a wider "xl" width while the cards
// are visible (matching the empty-1-on-1-page treatment).
export const meetingsShowingEmptyCardsVar = makeVar<Set<number>>(new Set());
